// Starting-scenario presets: the backdrop for a world's conversations.
// A scenario sets the SCENE line of the dialogue prompt ONLY — personalities,
// history, and sleep state still drive what NPCs actually talk about.
export interface Scenario {
  id: string;
  title: string;
  tagline: string;
  // 1-3 sentences of setting, written for the LLM prompt.
  scene: string;
  // Topic lean appended to the shared topic guidance.
  topicLean: string;
}

export const SCENARIOS: Scenario[] = [
  {
    id: 'communal',
    title: 'The Common Room',
    tagline: 'Waking up in a shared room with beds',
    scene: 'a shared common room — open floor, a few beds along the walls, nothing else. They cross paths here.',
    topicLean: 'the morning, food, rest, a rumor going around, something from their past, plans, an observation about life here',
  },
  {
    id: 'office',
    title: 'Paper Sales Office',
    tagline: 'Another day at the office of a paper sales company',
    scene: 'a drab regional office of a paper sales company — humming fluorescents, a break room with stale coffee, desks with ringing phones. They cross paths between tasks.',
    topicLean: 'quotas, the copier, a difficult client, office gossip, lunch plans, weekend plans, quiet job-hunting',
  },
  {
    id: 'dungeon',
    title: 'Dungeon, Day 999',
    tagline: 'Day 999 stuck in a dungeon',
    scene: 'a torch-lit dungeon they have been stuck in for 999 days — stone cells, a shared mess bench, routines worn into ritual. They cross paths in the common area.',
    topicLean: 'the mark on the wall, old escape plans, memories of outside, small kindnesses, festering grudges, what day 1000 should mean',
  },
  {
    id: 'reality-tv',
    title: 'Hidden Cameras',
    tagline: 'In a reality TV show with hidden cameras',
    scene: 'a brightly lit house full of hidden cameras — they all know they are being filmed for a reality show, with a confessional booth down the hall. They cross paths on camera.',
    topicLean: 'alliances, who is playing for the cameras, last night’s episode-worthy moment, nominations, missing home, performing vs. being real',
  },
  {
    id: 'diner',
    title: 'Night-Shift Diner',
    tagline: 'Graveyard shift at a roadside diner',
    scene: 'a roadside diner on the graveyard shift — flickering neon, cracked vinyl booths, a jukebox stuck on the same song, coffee always on. They cross paths between orders.',
    topicLean: 'regulars, the long night, tips, lives they left behind, small talk with strangers, what morning will bring',
  },
];

export const DEFAULT_SCENARIO_ID = 'communal';

export function scenarioById(id: string): Scenario {
  return SCENARIOS.find((s) => s.id === id) ?? SCENARIOS[0];
}
